<div class="location-management-container">
    <ul class="location-list">
        <li 
            *ngFor="let location of locations; let i = index; trackBy: trackByIndex" 
            class="location-item"
            [ngClass]="{ 'active': location.active }"
            (click)="changeView(i)">
            {{location.branch}}
        </li>
    </ul>

    <div class="mobile-location-tabs">
        <div class="tabs-container">
            <div 
                *ngFor="let location of locations; let i = index; trackBy: trackByIndex" 
                class="tab-item"
                [ngClass]="{ 'active': location.active }"
                (click)="changeView(i)">
                {{location.branch}}
            </div>
        </div>
    </div>
</div>
